module.exports = __webpack_public_path__ + "static/media/add post.e5af322f.svg";